// assets
import {IconHome,IconWorld,IconBuildingCottage } from '@tabler/icons';

// constant
const icons = {
    IconWorld,
    IconHome,
    IconBuildingCottage
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const geographyPages = {
    id: 'geography management',
    title: 'Geography Management',
    caption: 'Manage Geography List',
    type: 'group',
    children: [
        {
            id: 'country',
            title: 'Country',
            type: 'item',
            url: '/country/view',
            icon: icons.IconWorld
        },
        {
            id: 'state',
            title: 'State',
            type: 'item',
            url: '/state/View',
            icon:icons.IconBuildingCottage
        },
        {
            id: 'city',
            title: 'City',
            type: 'item',
            url: '/city/View',
            icon:icons.IconHome
        }

    ],

};

export default geographyPages;
